(function() {
  'use strict';

  angular.module('app').factory('NotifyService', NotifyService);

  NotifyService.$inject = ['$rootScope', '$translate'];

  function NotifyService($rootScope, $translate) {
    var service = {};

    $rootScope.flashMessages = [];
    $rootScope.ToastTitles = [];
    $rootScope.LastMessage = null;

    // Public service functions
    service.showToast = showToast;
    service.Success = Success;
    service.Warning = Warning;
    service.Error = Error;
    service.ErrorAPI = ErrorAPI;
    service.Remove = Remove;
    service.onTosterNotify = onTosterNotify;
    service.clearFlashMessage = clearFlashMessage;

    initService(service);
    initHeaders(service);
    // Init language headers
    $rootScope.$on('$translateChangeSuccess', function() {
      initHeaders(service);
    });

    return service;

    function initHeaders(service) {
      $translate(['Success', 'Error']).then(function(translations) {
        $rootScope.ToastTitles['success'] = translations['Success'];
        $rootScope.ToastTitles['error'] = translations['Error'];
      });
    }

    /**
     * Init started service
     */
    function initService(service) {

      // Default toast options
      toastr.options = {
        'closeButton': true,
        'debug': false,
        'positionClass': 'toast-top-right',
        'onclick': null,
        'showDuration': '10000',
        'hideDuration': '1000',
        'timeOut': '10000',
        'extendedTimeOut': '1000',
        'showEasing': 'swing',
        'hideEasing': 'linear',
        'showMethod': 'fadeIn',
        'hideMethod': 'fadeOut'
      };

      toastr.subscribe(service.onTosterNotify);

      /**
       * Remove messages when goto other page
       */
      $rootScope.$on('$locationChangeStart', function() {
        clearFlashMessage();
      });
    }

    /**
     * Remove messages from stack. If parameter isAll is False then messages with
     * flag isGlobal not removed
     * @param isAll {@boolean}: Remove all messages
     */
    function clearFlashMessage(isAll) {
      if (isAll) {
        $rootScope.flashMessages = [];
      } else {
        var newMessages = [];
        $rootScope.flashMessages.forEach(function(item, index) {
          if (item.isGlobal)
            newMessages[index] = item;
        });
        $rootScope.flashMessages = newMessages;
      }
    }

    /**
     * Callback for toast show or hide
     */
    function onTosterNotify(toast) {
      console.info('toastr', toast);
      if (toast.state === 'visible') {
        $rootScope.flashMessages[toast.toastId] = $rootScope.LastMessage;
      } else {
        if (toast.state === 'hidden') {
          delete $rootScope.flashMessages[toast.toastId];
        }
      }
    }

    /**
     * Display toast and save this to
     */
    function showToast(msg) {
      $translate([msg.message]).then(function(translations) {
        // list codes which is handled inline
        // 1: mail or phone already used by someone
        // 2: wrong user or password, password to short, etc
        // will be extended on new
        var isToastMsg = msg.code != 1
            && msg.code != 2
            && msg.code != 4
            && msg.code != 5
            && msg.code != 11
            && msg.code != 30
            && msg.code != 32
            && msg.code != 62
            && msg.code != 71
            && msg.code != 113;

        if (isToastMsg) {
          $rootScope.LastMessage = msg;

          if (msg.cleanBeforeShow)
            toastr.remove();

          toastr[msg.type](translations[msg.message], msg.type == 'success' ? null : $rootScope.ToastTitles[msg.type]);
        }
      });
    }

    function Success(message, isGlobal) {
      if (!message) message = 'Data saved';
      showToast({
        code: 0,
        message: message,
        type: 'success',
        isGlobal: isGlobal
      });
    }

    function Warning(message, isGlobal) {
      showToast({
        code: 0,
        message: message,
        type: 'warning',
        isGlobal: isGlobal
      });
    }

    function Error(message, isGlobal) {
      showToast({
        code: 0,
        message: message,
        type: 'warning',
        isGlobal: isGlobal
      });
    }

    function ErrorAPI(data) {
      // TODO Error codes to const
      var _type = (data.code && [30].indexOf(data.code) !== -1) ? 'warning' : 'error';
      showToast({
        code: data.code,
        message: data.description ? data.description : data.message,
        type: _type,
        isGlobal: false,
        cleanBeforeShow: true
      });
    }

    function Remove(index) {
      if (!Number.isInteger(index)) { // this msg Object
        index = $rootScope.flashMessages.indexOf(index);
      }
      if (index > -1)
        $rootScope.flashMessages.splice(index, 1);
    }
  }

})();